<template>
  <div v-if='gotData' >      
    <hr>
    <div class="row">   
        <div class="col-xs-6 col-md-6">
            <span class='carViewTitle'> {{ ItemsDetails[0].title }}  </span>
        </div>
        <div class="col-xs-6 col-md-6">            
            <span class='carViewOfferPrice' >Ahora: {{ ItemsDetails[0].currency_name }}${{ ItemsDetails[0].offerprice | AddCommasToNumber }}</span>
            <br>
            <span class='carViewPrice'>Antes: {{ ItemsDetails[0].currency_name }}$<strike>{{ ItemsDetails[0].price |  AddCommasToNumber}}</strike></span>
        </div>
    </div>    
    <hr>
     <div class="row">   
        <div class="col-xs-12 col-md-12">
            <span class='carPath' >  {{ ItemsDetails[0].typevehicle_name }} / {{ ItemsDetails[0].car_brand_name }} / {{ ItemsDetails[0].car_model_name }} </span>
        </div>
     </div>
    <hr>
    <div class="row">   
        <div class="col-xs-12 col-md-12" >
          <Gallery  v-bind:id='ItemsDetails[0].id' ></Gallery>
        </div>   
    </div>   
    <div class="row infoMargin">           
        <div  class="col-xs-12 col-md-12">
            <span class='boldClass datosGenerales' >Información del vehículo</span>
            <br><br>
            <div class="row detalles">   
                <div class="col-xs-6 col-md-5">                                 
                    <span > <span class='boldClass'>Marca:</span>     {{ ItemsDetails[0].car_brand_name }}  </span><br />
                    <span > <span class='boldClass'>Modelo:</span>    {{ ItemsDetails[0].car_model_name }}  </span><br />
                    <span > <span class='boldClass'>Año:</span>       {{ ItemsDetails[0].model_year }}  </span><br />
                    <span > <span class='boldClass'>Pasajeros:</span> {{ ItemsDetails[0].passengers }}  </span><br />            
                    <span > <span class='boldClass'>Cilindros:</span> {{ ItemsDetails[0].enginecylinders }}  </span><br />
                    <span > <span class='boldClass'>Tipo:</span>      {{ ItemsDetails[0].typevehicle_name }}  </span><br />
                    <span > <span class='boldClass'>Puertas:</span>   {{ ItemsDetails[0].doors }}  </span><br />                                
                    <span > <span class='boldClass'>Traccion:</span>  {{ ItemsDetails[0].tractiontype_name }}  </span><br />                                                    
                </div>               
                <div class="col-xs-6 col-md-7">                         
                    <span > <span class='boldClass'>Precio oferta:</span>  {{ ItemsDetails[0].currency_name }}${{ ItemsDetails[0].offerprice |  AddCommasToNumber}} </span><br />
                    <span > <span class='boldClass'>Precio regular:</span> {{ ItemsDetails[0].currency_name }}$<strike>{{ ItemsDetails[0].price |  AddCommasToNumber}}</strike> </span><br />
                    <span > <span class='boldClass'>Kilometraje:</span>    {{ ItemsDetails[0].odometer | AddCommasToNumber }}  </span><br />
                    <span > <span class='boldClass'>Color Exterior:</span> {{ ItemsDetails[0].exteriorcolor_name }}  </span><br />
                    <span > <span class='boldClass'>Color Interior:</span> {{ ItemsDetails[0].interiorcolor_name }}  </span><br />
                    <span > <span class='boldClass'>Motor CC:</span>       {{ ItemsDetails[0].enginecc }}  </span><br />                    
                    <span > <span class='boldClass'>Combustible:</span>    {{ ItemsDetails[0].fueltype_name }}  </span><br />
                    <span > <span class='boldClass'>Transmission:</span>   {{ ItemsDetails[0].transmissiontype_name }}  </span><br />                                        
                </div>                                       
            </div>          
            <hr>
            <div class="row">   
                <div class="col-xs-12 col-md-12"> 
                    <!--<span class='boldClass datosGenerales' >Descripcion del vehículo</span><br><br>-->
                    
                    <span class='descripcion'>{{ ItemsDetails[0].description }}</span><br />                    
                </div>
            </div>
            <hr>
            <InquiryCalculator v-bind:ItemsDetail='ItemsDetails[0]' ></InquiryCalculator>
            <hr>

        </div>
    </div>  
    <hr>        
  </div>
</template>

<script>
import { eventBus } from '../main';
export default {  
  data: function () {     
    return {
       gotData:false,
       ItemsDetails: [{}],
       imageLists: [],
       imageFolderPath: '/uploads/',
       carid:0,
    }
  },
  mounted: function () {     
      this.carid = this.$route.params.id;   
      this.getItemsDetails();
  },
  methods: {
    getItemsDetails: function() {              
        this.$http.get('api/carforsale/' + this.carid).then(response => {   

            this.ItemsDetails = response.body.map(obj =>{                                                             
                obj.showDetails = false;                
                this.getCarImages(obj);
                return obj;
            });                                    
                                                     
        }, response => {            
            eventBus.$emit('errorMsg',response);
        });
    },      
    getCarImages : function(obj){

        this.$http.get('api/imageupload/carid/' + obj.id).then(response => {                         
           this.imageLists = response.body.map(function(imageListsObj){                
                return imageListsObj.name;
           });                      
           this.gotData = true;                     
        }, response => {            
            eventBus.$emit('errorMsg',response);
        });
    }
  },
  filters: {
     
  },
  computed: {
    
  },  
}
</script>

<style scoped> 
   .infoMargin {
       margin-left: 15px;
   }
   .carViewTitle {
        font-weight: bold;
        color: #2D80C7;
        font-size: 36px;        
   }

    .carViewOfferPrice{
        font-weight: bold;
        color: red;
        font-size:1.8em;        
    }

    .carViewPrice{
        font-weight: bold;
        color:red;
        font-size:1.8em;        
    }
    
    .carPath {    
        font-size:1.7em;
        color: #2D80C7;
    }
    
    ul {
        list-style: none;
    }

    .carPhotosList div {
       float: left;       
       margin: 5px;       
    }

    .boldClass {
       font-weight: bold;
    }

    .datosGenerales {
        font-weight:500;
        color: red;
        font-size: 1.8em;        
    }
   
   .detalles {
          font-size: 1.4em;
    }

    .descripcion {
        font-size: 1.4em;
    }

  @media screen and (max-width: 981px) {  
        
      .detalles {
          font-size: 2.4em;
      }

      .descripcion {
          font-size: 2.4em;
      }

      .datosGenerales {
        font-size: 4em;
      }

      .carViewTitle {
        font-size: 5em;
      }

      .carViewOfferPrice {
        font-size: 4em;
      }

      .carViewPrice {
        font-size: 4em;
      }

      .carPath {
        font-size: 3em;
      }

   }

  @media screen and (min-width: 981px) {          
      
      
   }

</style>



// WEBPACK FOOTER //
// CarForSaleView.vue?04d2689b